import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector } from "react-redux";
import api from "../../utils/api";

const DeleteCellRenderer = (props) => {
  const APIBASE_URL = process.env.REACT_APP_APIBASE_URL;
  const [open, setOpen] = useState(false);
  const [warnopen, setWarnOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const MemberCode = useSelector((state) => state.memberreducer.MemberCode);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseOkay = () => {
    setOpen(false);
    setWarnOpen(false);
  };

  const getCarrierResultCode = (data) => {
    if (data == null) return NaN;
    if (typeof data === "object") {
      return Number(
        data.returnValue ?? data.detail ?? data.recordset?.[0] ?? NaN
      );
    }
    return Number(data);
  };

  const deleteCarrier = () => {
    api
      .post(
        `${APIBASE_URL}/GreenCarrier?MemberCode=${MemberCode}&SCAC=${props.value}&Delete=1`
      )
      .then((resp) => {
        const resultCode = getCarrierResultCode(resp.data);
        if (resultCode === 1) {
          setOpen(false);
          if (props.onDeleteSuccess) {
            props.onDeleteSuccess();
          } else {
            props.update();
          }
        }
        if (resultCode === 2) {
          setOpen(false);
          setWarnOpen(true);
        }
      });
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <DeleteIcon></DeleteIcon>
      </Button>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Please confirm Delete action"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete this Carrier? This action can not be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={deleteCarrier} color="primary" autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={warnopen}
        onClose={handleCloseOkay}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title-1">
          {"Cannot Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          This carrier has existing shipments. Deletion is not allowed.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseOkay} color="primary">
            Okay
          </Button>
         
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteCellRenderer;
